import ResultsTableContainer from './ResultsTableContainer';

export default ResultsTableContainer;
